import { render, staticRenderFns } from "./customerProperty.vue?vue&type=template&id=20f281c6&"
import script from "./customerProperty.vue?vue&type=script&lang=js&"
export * from "./customerProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f281c6')) {
      api.createRecord('20f281c6', component.options)
    } else {
      api.reload('20f281c6', component.options)
    }
    module.hot.accept("./customerProperty.vue?vue&type=template&id=20f281c6&", function () {
      api.rerender('20f281c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/customerProperty.vue"
export default component.exports